import { omit } from 'lodash'

export const productConventer = {
  toFirestore(data) {
    return omit(data, ['id'])
  },
  fromFirestore(doc, options) {
    const data = doc.data(options)

    return {
      ...data,
      createdAt: data?.createdAt?.toDate() || null,
      deletedAt: data?.deletedAt?.toDate() || null,
      id: doc.id,
    }
  },
}
